import { styled } from "styled-components";
import { screenSizes } from "../../constants/breakpoints";

export const TermsAndConditionsContainer = styled.div`
  height: 100%;
  position: relative;
  .terms {
    overflow-y: scroll;
    height: 75%;
    margin: 24px 0px;
    padding-right: 16px;
    padding-bottom: 40px;
    &::-webkit-scrollbar {
      width: 4px;
      background: #f5f6ee;
    }
    &::-webkit-scrollbar-thumb {
      background: #daff41;
    }
    p {
      font-family: 'TomatoGrotesk';
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
    }
  }
  .shadow {
    background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 1),
      rgba(255, 255, 255, 0)
    );
    height: 150px;
    width: 100%;
    position: absolute;
    bottom: 150px;
  }
  button {
    display: block;
    background-color: #daff41;
    border: 0px;
    padding: 10px 32px;
    font-size: 14px;
    font-weight: 700;
    border-radius: 64px;
    margin: 40px auto 0px;
    cursor: pointer;
  }
  h2 {
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: 600;
  }

  p {
    margin-bottom: 16px;
    color: #4c4c4c;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
  }
  a,
  a:active,
  a:visited,
  a:hover {
    color: #3582f5;
  }
`;
export const Container = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  gap: 2em;
  padding: 0 15px;
`
export const Main = styled.div`
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: start;
  gap: 1em;
  padding: 0 2em;
  max-width: 1140px;
  @media (max-width: ${screenSizes.mediaMM}px) {
    padding: 1em 10px 0em 10px;
  }
  @media (max-width: ${screenSizes.mediaXS}px) {
    padding: 1em 0em 2em 0em;
  }
  padding-top: 64px;
`